import React, { memo } from "react";
import { useFocusable } from "@noriginmedia/norigin-spatial-navigation";
import { scrollIntoViewWithinContainer } from "../utils/shared/scrollIntoView";

export const KEYBOARD_SCROLL_CONTAINER = "epgKeyboard";

const KeyboardKey = memo(({ label, value, focusKey, onPress, icon, wide, full }) => {
    const { ref, focused } = useFocusable({
        focusKey,
        onEnterPress: () => onPress(value),
        onFocus: () => {
            if (ref.current) scrollIntoViewWithinContainer(ref.current, KEYBOARD_SCROLL_CONTAINER);
        },
    });

    const cls = ["kbKey", wide && "kbKey--wide", full && "kbKey--full", focused && "focused"]
        .filter(Boolean)
        .join(" ");

    return (
        <button ref={ref} className={cls} onClick={() => onPress(value)} tabIndex={-1} aria-label={label}>
            {icon && <img src={icon} alt="" className="kbKey__icon" />}
            {label}
        </button>
    );
});

export default KeyboardKey;
